<div #inicioOcorrencias></div>
<div class="col-12" *ngIf="load">
    <div class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div>

<div class="col-12" *ngIf="!recursoDesdobramento.loadHistoricoOcorrencia && !load">
    <ng-container *ngFor="let ocorrencia of recursoDesdobramento.historicosProcessoOcorrencias; let i = index; trackBy: trackByOcorrencia">

        <div class="d-flex">
            <div class="col-11"></div>

            <div class="d-flex justify-content-end col-1">
                <div class="btn-adicionar"
                    (click)="ocorrencia.menuEdivarVisible = !ocorrencia.menuEdivarVisible">
                    <i class="fas fa-ellipsis-v"></i>
                </div>

                <div class="menu-detalhes"
                    (mouseover)="ocorrencia.menuEdivarVisible = true"
                    (mouseleave)="ocorrencia.menuEdivarVisible = false"
                    [hidden]="!ocorrencia.menuEdivarVisible">
                    <ul>
                        <li><a (click)="editarOcorrencia(ocorrencia)">Editar</a></li>
                        <li><a (click)="excluirOcorrencia(ocorrencia)">Excluir</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="d-flex">
            <div class="pr-3">
                {{ ocorrencia.dataOcorrencia | date: 'dd/MM/yyyy' }}
            </div>

            <div class="d-flex justify-content-between col-12">
                <div class="tipo-ocorrencia">
                    <div class="d-flex">
                        <i class="far fa-copy mr-2"></i>

                        <b (click)="toogleTipoOcorrencia(i)">
                            {{ ocorrencia.tipoOcorrenciaNome }}

                            <span *ngIf="ocorrencia.qtdLines > 2.8">
                                {{ !ocorrencia.showTipoOcorrencia ? '[+]' : '[-]' }}
                            </span>
                        </b>

                        <i *ngIf="ocorrencia.exibirParaCliente"
                           class="fa fa-eye ml-2"
                           ngbTooltip="Visível para o cliente"></i>
                    </div>

                    <div class="mt-2" style="font-size: small;">
                        <i class="fas fa-user-edit"></i>
                        Cadastrado por {{ ocorrencia.pessoaCadastro }}
                        em {{ ocorrencia.dataCriacao | date: 'dd/MM/yyyy' }}
                    </div>

                    <p
                        #tipoDescricao
                        class="tipo-descricao"
                        style="line-height: 22px;"
                        [ngClass]="{
                            'collapse-desc': !ocorrencia.showTipoOcorrencia && ocorrencia.qtdLines > 2.8
                        }">
                        {{ ocorrencia.descricao }}
                    </p>
                </div>
            </div>
        </div>

        <div class="col-12 ml-4">
            <div class="row" *ngFor="let atividade of ocorrencia.detalhes; trackBy: trackByAtividade">
                <div class="col-2"></div>

                <div class="col-10">
                    <app-card-ocorrencia-atvd-detalhe
                        [atividade]="atividade"
                        [recursoDesdobramento]="ocorrencia"
                        (openModalComments)="openModalComments($event)"
                        (editarAtividade)="editarAtividade($event)"
                        (excluirAtividade)="excluirAtividade($event)">
                    </app-card-ocorrencia-atvd-detalhe>
                </div>

                <div class="col-2"></div>

                <div class="col-10" *ngIf="atividade.editarDetalhes && atividade.tipoOcorrencia == 2">
                    <tarefas-detalhes
                        tarefaId="{{ atividade.id }}"
                        tarefaDetalhes="{{ atividade }}"
                        (changeQuantidade)="onChangeQuantidade(atividade, false, $event)"
                        (changeQuantidadeOcultando)="onChangeQuantidade(atividade, true, $event)"
                        (changeConcluirTarefa)="onChangeConcluirTarefa(atividade, $event)">
                    </tarefas-detalhes>
                </div>

                <div class="col-10" *ngIf="atividade.editarDetalhes && atividade.tipoOcorrencia == 3">
                    <eventos-detalhes
                        eventoId="{{ atividade.id }}"
                        eventoDetalhes="{{ atividade }}"
                        (changeConcluirEvento)="onChangeConcluirEvento(atividade, $event)"
                        (changeQuantidadeOcultando)="onChangeQuantidade(atividade, true, $event)">
                    </eventos-detalhes>
                </div>

                <div class="col-10" *ngIf="atividade.editarDetalhes && atividade.tipoOcorrencia == 4">
                    <prazo-detalhes
                        prazoId="{{ atividade.id }}"
                        prazoDetalhes="{{ atividade }}"
                        (changeConcluirPrazo)="onChangeConcluirPrazo(atividade, $event)"
                        (changeQuantidadeOcultando)="onChangeQuantidade(atividade, true, $event)">
                    </prazo-detalhes>
                </div>
            </div>
        </div>

    </ng-container>

    <div class="row mt-3" *ngIf="totalItens > itensPorPagina">
        <div class="col-12 d-flex justify-content-between align-items-center">
            <span class="text-muted">
                Página {{ paginaAtual }} de {{ totalPaginas }} - {{ totalItens }} ocorrências
            </span>

            <ngb-pagination
                [maxSize]="10"
                [collectionSize]="totalItens"
                [pageSize]="itensPorPagina"
                [(page)]="paginaAtual"
                [boundaryLinks]="true"
                (pageChange)="alterarPagina($event)"
                size="sm">
            </ngb-pagination>
        </div>
    </div>
</div>